import { root } from './views';

export const views = {
  ...root,
};
